const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1';

export type SignatureTokenStatus = 'PENDING' | 'USED' | 'EXPIRED' | 'INVALID';

export interface SignatureTokenCreateResponse {
  token: string;
  reportId: string;
  expiresAt: string;
}

export interface SignatureTokenInfoResponse {
  reportId: string;
  reportNumber: string;
  customerName: string;
  expiresAt: string;
}

export interface SignatureTokenStatusResponse {
  status: SignatureTokenStatus;
}

export function buildSignatureUrl(token: string): string {
  return `${window.location.origin}/#/sign/${token}`;
}

export async function generateSignatureToken(
  reportId: string,
  authHeader: string
): Promise<SignatureTokenCreateResponse> {
  const response = await fetch(`${API_BASE_URL}/signature-tokens`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: authHeader,
    },
    body: JSON.stringify({ reportId }),
  });
  if (!response.ok) {
    throw new Error(`Failed to generate signature token: ${response.status}`);
  }
  return response.json();
}

export async function getSignatureTokenInfo(
  token: string
): Promise<SignatureTokenInfoResponse> {
  const response = await fetch(`${API_BASE_URL}/public/signature-tokens/${token}`);
  if (!response.ok) {
    throw new Error(`Token not valid: ${response.status}`);
  }
  return response.json();
}

export async function getSignatureTokenStatus(
  token: string
): Promise<SignatureTokenStatusResponse> {
  const response = await fetch(
    `${API_BASE_URL}/public/signature-tokens/${token}/status`
  );
  if (!response.ok) {
    throw new Error(`Failed to get token status: ${response.status}`);
  }
  return response.json();
}

export async function submitSignature(
  token: string,
  signatureContent: string
): Promise<void> {
  const response = await fetch(
    `${API_BASE_URL}/public/signature-tokens/${token}/submit`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ signatureContent }),
    }
  );
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const message = (body as { message?: string }).message || `Error ${response.status}`;
    throw new Error(message);
  }
}
